import React from 'react';
import PropTypes from 'prop-types';
import ImageV2 from 'components_v2/common/ImageV2';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import WithNativeCampaign from 'helpers/ads/WithNativeCampaign';
import { setPageConfigAndSendIBeatCall } from 'utils/iBeatConfig';
import { toggleLoginBox } from 'components/Login/redux';
import { incrementAdsCounter } from 'helpers/ads/redux';
import { loadInterstitialMobileAttachEvents } from 'helpers/interstitial/interstitialMobile';
import { getExperimentRefresh } from 'utils/experimentUtils';
import TrendingSlider from 'components_v2/desktop/TrendingSlider/TrendingSlider';
import TrendingMarquee from '../../components_v2/mobile/TrendingMarquee/TrendingMarquee';
import { IMAGE_URL } from '../../constants';
//import AdFreeNudge from 'components/AdFreeNudge/';
//import { isPrimeNotActive } from 'utils/primeUtil';

import { clearVideosData } from './redux';
import s from './Videos.scss';
import CategoryListing from './CategoryListing';
import Heading from './Heading';
import Videosearch from '../../components/videosearch/Videosearch';
import AdCaller from '../../helpers/ads/adCaller';
//import TimesTop10 from '../../components/TimesTop10/WithTimesTop10';

const getLoaderListItem = count => {
  const loaders = [];
  for (let i = 0; i < count; i += 1) {
    loaders.push(
      <li>
        <div className={`${s.inner} ${s.divider}`} />
        <div className={`${s.inner} ${s.left}`} />
        <div className={`${s.inner} ${s.right}`} />
        <div className={`${s.inner} ${s.divider} ${s.divider1}`} />
        <div className={`${s.inner} ${s.left} ${s.left1}`} />
        <div className={`${s.inner} ${s.right} ${s.right1}`} />
        <div className={`${s.inner} ${s.divider} ${s.bottom}`} />
      </li>,
    );
  }
  return loaders;
};

class Videos extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      (!prevProps.userData.isLoggedIn && this.props.userData.isLoggedIn) ||
      (prevProps.userData.isLoggedIn && !this.props.userData.isLoggedIn)
    ) {
      if (this.props.isHistoryPage) {
        if (typeof window === 'object') {
          this.props.clearVideosData();
          // this.props.loadHistoryData();
        }
      } else if (this.props.isWatchLaterPage) {
        if (typeof window === 'object') {
          this.props.clearVideosData();
          // this.props.getWatchLaterData(this.props.contextParams, 5);
        }
      }
    }
  }
  componentDidMount() {
    getExperimentRefresh(this.props.refreshTime);
    setPageConfigAndSendIBeatCall(this.props.videosData, this.props.isWapView);
    if (this.props.isWapView) {
      loadInterstitialMobileAttachEvents();
    }
  }

  getWebMidAds = i => {
    const { midAds: { mid1 = {}, mid2 = {} } = {} } = _get(
      this.props,
      'revenueAds.dfp',
      {},
    );

    let adData;
    if (mid1.position && mid1.position.includes(`${i}`)) {
      adData = mid1;
    } else if (mid2.position && mid2.position.includes(`${i}`)) {
      adData = mid2;
    }
    return (
      adData && (
        <AdCaller
          lazyClassName={s.lazyClassName}
          data={{ ...adData, divId: `${adData.divId}-${i}` }}
          className={s.videoAdContainer}
        />
      )
    );
  };

  integrateMwebAds = (i, sectionsArr) => {
    const mrecs = _get(this.props, 'revenueAds.dfp.mrecs', {});
    let mrec;
    const mreckeys = Object.keys(mrecs);
    for (let idx = 0; idx < mreckeys.length; idx += 1) {
      const val = mrecs[mreckeys[idx]];
      const indexOfAd = val.position && val.position.indexOf(`${i - 1}`);
      if (indexOfAd > -1) {
        mrec = val;
        break;
      }
    }

    if (mrec) {
      let itemToBePushed = null;
      const adComp = (
        <AdCaller
          lazyClassName={s.lazyClassName}
          // className="section-ad"
          data={{ ...mrec, divId: `${mrec.divId}-${i}` }}
          className={s.videoAdContainer}
          deviceType="mobile"
        />
      );
      if (!this.isMrecPlusPlusDone) {
        this.isMrecPlusPlusDone = true;
        itemToBePushed = (
          <WithNativeCampaign type="mrecplusplus">{adComp}</WithNativeCampaign>
        );
      } else {
        itemToBePushed = adComp;
      }
      sectionsArr.push(itemToBePushed);
    }
  };

  renderSections = (sections, parentPath, isWapView) => {
    const { mrecs: { mrec = {} } = {} } = _get(
      this.props,
      'revenueAds.dfp',
      {},
    );
    const sectionsArr = [];
    for (let i = 0; i < sections.length; i += 1) {
      if (isWapView) {
        this.integrateMwebAds(i, sectionsArr);
      }
      const slidesToshow = [
        {
          withAd: 3.7,
          withoutAd: 5.1,
        },
        {
          withAd: 3,
          withoutAd: 4.4,
        },
        {
          withAd: 3,
          withoutAd: 4.4,
        },
      ];
      const categoryComponent = (
        <CategoryListing
          parentPath={parentPath}
          category={sections[i]}
          isWapView={this.props.isWapView}
          watchLaterObj={this.props.watchLater}
          removeFromWatchLater={this.removeFromWatchLater}
          adClass={s.videoAdContainer}
          geoData={this.props.geoCityData}
          incrementAdsCounter={this.props.incrementAdsCounter}
          slidesToShow={!isWapView && slidesToshow}
          hasMrecAd={!isWapView && i === 0}
        />
      );
      if (mrec.adCode && i === 0 && !isWapView) {
        sectionsArr.push(
          <div className={s.rhs_mrec}>
            {categoryComponent}
            <AdCaller data={mrec} />
          </div>,
        );
      } else {
        sectionsArr.push(categoryComponent);
        if (!isWapView) {
          const adCompWEB = this.getWebMidAds(i);
          sectionsArr.push(adCompWEB);
        }
      }
    }
    return sectionsArr;
  };
  addToWatchLater = () => {
    if (!this.props.userData.isLoggedIn) {
      this.props.toggleLoginBox(true);
    }
  };
  removeFromWatchLater = () => {
    if (!this.props.userData.isLoggedIn) {
      this.props.toggleLoginBox(true);
    }
  };

  render() {
    const {
      videosData,
      linkslistData,
      videoListData = {},
      isHistoryPage,
      isWatchLaterPage,
      videosearchdata,
      logoutError,
      historyError,
      watchLaterError,
      isWapView,
      topSearches,
      topSearchesV2,
    } = this.props;
    const adsData = isWapView
      ? videoListData.mobileAdsData
      : videoListData.adsData;
    const { banner } = videoListData;
    const { atfcontent } = videoListData;
    this.state = { ...this.state };
    let classForMobile = '';
    if (this.props.isWapView) {
      classForMobile = s['mobile-view'];
    }

    //const { prcValue = 0 } = this.props.userData;
    let showVideoSearch = false;
    this.isMrecPlusPlusDone = false;
    if (
      videosearchdata &&
      (Array.isArray(videosearchdata.Documents) ||
        videosearchdata.Documents === '')
    ) {
      showVideoSearch = true;
    }
    if (showVideoSearch) {
      return (
        <Videosearch
          watchLaterObj={this.props.watchLater}
          addToWatchLater={this.addToWatchLater}
          removeFromWatchLater={this.removeFromWatchLater}
        />
      );
    } else if (videosData) {
      return (
        <div
          className={`wrapperclearfix ${s.main_content} appFullWidth`}
          data-translate-id="cw"
        >
          <div className={`${s.videosContent} video_listing`}>
            {!isWapView &&
              Array.isArray(topSearches) &&
              topSearches.length && (
                <TrendingSlider topSearches={topSearches} />
              )}

            {banner &&
              banner.msid && (
                <div className={s.topBannerWrap}>
                  <ImageV2 src={`${IMAGE_URL}${banner.msid}.cms`} alt="" />
                </div>
              )}

            {!isWapView &&
              !Array.isArray(topSearches) &&
              topSearchesV2 &&
              Array.isArray(topSearchesV2.items) &&
              topSearchesV2.items.length > 0 && (
                <TrendingSlider topSearches={topSearchesV2.items} />
              )}
            {isWapView &&
              !Array.isArray(topSearches) &&
              topSearchesV2 &&
              Array.isArray(topSearchesV2.items) &&
              topSearchesV2.items.length > 0 && (
                <TrendingMarquee topSearches={topSearchesV2.items} />
              )}
            {videosData.h1 ? (
              <Heading
                parentPath={videosData.path}
                name={videosData.h1}
                titleSuffix={videosData.suffix}
                headingType="h1"
              />
            ) : (
              ''
            )}
            {/* {this.shouldShowAdFreeNudge(prcValue) && (
              <AdFreeNudge
                userData={this.props.userData}
                isWapView={this.props.isWapView}
                parentSocialWidgetVisible={this.state.parentSocialWidgetVisible}
                page="videos"
              />
            )} */}
            {videosData.description &&
            videosData.h1 &&
            !this.props.isWapView ? (
              <div className={s.description}>{videosData.description}</div>
            ) : (
              ''
            )}

            {videosData.sections ? (
              this.renderSections(
                videosData.sections,
                videosData.path,
                isWapView,
              )
            ) : (
              <CategoryListing
                parentPath={videosData.path}
                category={videosData}
                isWapView={this.props.isWapView}
                watchLaterObj={this.props.watchLater}
                addToWatchLater={this.addToWatchLater}
                removeFromWatchLater={this.removeFromWatchLater}
                adsData={adsData}
                hideMoreBtn
                adClass={s.videoAdContainer}
                geoData={this.props.geoCityData}
                incrementAdsCounter={this.props.incrementAdsCounter}
                atfcontent={atfcontent}
              />
            )}
          </div>

          {!isHistoryPage &&
            !isWatchLaterPage && (
              <div
                className={`${s.more_from_toi_top_videos} ${classForMobile}`}
              >
                {linkslistData ? (
                  <CategoryListing
                    parentPath={videosData.path}
                    category={linkslistData}
                    geoData={this.props.geoCityData}
                    linkslistData
                    incrementAdsCounter={this.props.incrementAdsCounter}
                  />
                ) : null}
              </div>
            )}
        </div>
      );
    } else if (logoutError) {
      return (
        <div
          className={`${s.main_content} appFullWidth`}
          data-translate-id="cw"
        >
          <Heading name={logoutError.title} titleSuffix={logoutError.suffix} />
          <div>
            <div className={s.messageBox}>
              {logoutError.title} {logoutError.suffix} {"isn't"} viewable when
              Logged out. Please{' '}
              <button onClick={() => this.props.toggleLoginBox(true)}>
                {' '}
                Login
              </button>{' '}
              and try again.
              <br />
            </div>
          </div>
        </div>
      );
    } else if (historyError) {
      return (
        <div
          className={`${s.main_content} appFullWidth`}
          data-translate-id="cw"
        >
          <Heading
            name={historyError.title}
            titleSuffix={historyError.suffix}
          />
          <div>
            <div className={s.messageBox}>
              You haven&apos;`t watched any videos yet. Start watching Videos
              now.
              <br />
            </div>
          </div>
        </div>
      );
    } else if (watchLaterError) {
      return (
        <div
          className={`${s.main_content} appFullWidth`}
          data-translate-id="cw"
        >
          <Heading
            name={watchLaterError.title}
            titleSuffix={watchLaterError.suffix}
          />
          <div>
            <div className={s.messageBox}>
              You haven&apos;t added any videos to Watch Later yet.
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={s.loader} data-translate-id="cw">
        <div className={s.placeholder}>
          <ul>{getLoaderListItem(this.props.isWapView ? 4 : 10)}</ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  videosData: state.videos.data,
  watchLater: state?.videos?.watchLater,
  videoListData: state?.videos?.videoListData || {},
  linkslistData: state?.videos?.linkslistData,
  userData: _get(state, 'login.userData', {}),

  videosearchdata: state?.videosearch?.data,
  logoutError: state?.videos?.logoutError,
  historyError: state?.videos?.historyError,
  watchLaterError: state?.videos?.watchLaterError,
  geoCityData: state?.geo?.cityData,
  revenueAds: _get(state, 'revenue.data.ads.content'),
  topSearches: _get(state, 'navigation.data.topSearchArray', undefined),
  topSearchesV2: _get(state, 'commonData.data.topSearches', undefined),
});

const mapDispatchToProps = dispatch => ({
  toggleLoginBox: isOpen => {
    dispatch(toggleLoginBox(isOpen));
  },
  clearVideosData: () => {
    dispatch(clearVideosData());
  },
  // loadHistoryData: () => {
  //   dispatch(loadHistoryData());
  // },
  // getWatchLaterData: (params, no) => {
  // dispatch(getWatchLaterData(params, no));
  // },
  incrementAdCounter: () => {
    dispatch(incrementAdsCounter());
  },
});

Videos.propTypes = {
  videosData: PropTypes.shape({}).isRequired,
  watchLater: PropTypes.shape({}),
  isWapView: PropTypes.bool,
  adsData: PropTypes.shape({}),
  linkslistData: PropTypes.shape({}),
  userData: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
    prcValue: PropTypes.number,
  }),
  toggleLoginBox: PropTypes.shape({}).isRequired,
  videoListData: PropTypes.shape({}).isRequired,
  isHistoryPage: PropTypes.bool.isRequired,
  isWatchLaterPage: PropTypes.bool.isRequired,
  videosearchdata: PropTypes.shape({}),
  logoutError: PropTypes.shape({}),
  historyError: PropTypes.shape({}),
  watchLaterError: PropTypes.shape({}),
  contextParams: PropTypes.shape({}),
  clearVideosData: PropTypes.func.isRequired,
  // loadHistoryData: PropTypes.func.isRequired,
  // getWatchLaterData: PropTypes.func.isRequired,
  geoCityData: PropTypes.shape({}),
  incrementAdsCounter: PropTypes.func,
  refreshTime: PropTypes.number,
};

Videos.defaultProps = {
  isWapView: false,
  watchLater: {},
  adsData: [],
  linkslistData: [],
  userData: undefined,
  videosearchdata: {},
  logoutError: undefined,
  historyError: undefined,
  watchLaterError: undefined,
  contextParams: {},
  geoCityData: undefined,
  incrementAdsCounter: undefined,
  refreshTime: 0,
};

export default connect(mapStateToProps, mapDispatchToProps)(Videos);
